module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "xudong-zhao-square.065348e7.png" + "?" + Date.now();